module.exports = function ($ocLazyLoadProvider) {
    $ocLazyLoadProvider.config({
        modules: 'wowModules' in window ? window.wowModules : [],
    });
};



// WEBPACK FOOTER //
// ./src/configuration/modules.js